import { STORE_API } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IStoreRepository } from "features/storeManagement/domain/repositories/IStoreRepository";
import { injectable } from "tsyringe";
import { StoreFormRequestModel } from "./model/StoreFormRequestModel";
import { StoreRequestModel } from "./model/StoreRequestModel";
import { StoreResponseModel } from "./model/StoreResponseModel";

@injectable()
export class StoreImpl implements IStoreRepository {
  async getStores(
    params: StoreRequestModel,
  ): Promise<ListBaseApiResponseModel<StoreResponseModel>> {
    return await client.get(STORE_API.LIST, params);
  }

  async getStoreDetail(
    code: string,
  ): Promise<BaseApiResponseModel<StoreResponseModel>> {
    return await client.get(STORE_API.DETAIL, { code });
  }

  async createStore(
    body: StoreFormRequestModel,
  ): Promise<BaseApiResponseModel<StoreResponseModel>> {
    return await client.post(STORE_API.CREATE, body);
  }

  async updateStore(
    body: StoreFormRequestModel,
  ): Promise<BaseApiResponseModel<StoreResponseModel>> {
    return await client.put(`${STORE_API.UPDATE}?code=${body?.code}`, body);
  }

  async deleteStore(
    code: string,
  ): Promise<BaseApiResponseModel<StoreResponseModel>> {
    return await client.delete(STORE_API.DELETE, { code });
  }
}
